import React, { useState, useRef } from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import Topbar from '../Tools/Topbar';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';
import { Newspaper } from 'lucide-react';

const News = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const {settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings 
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}  // Add this line
            />
          
          <div class="card w-100 position-relative overflow-hidden">
            <div class="px-4 py-3 ">
              <h5 class="card-title fw-semibold mb-0 lh-sm">News & Updates</h5>
              <p class="card-subtitle mb-0 mt-1">Stay informed with the latest updates and announcements from the system team.</p>
            </div>
            <div class="card-body p-4">
              <div class="row">
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">New Feature</span>
                      <h4 class="card-title my-3">Smart Resource Matching</h4>
                      <h6 class="fs-2 mb-3">Date:  June 22, 2025</h6>
                      <p class="card-text">
                        Our AI engine now intelligently matches resources to submitted cases for improved allocation.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">Maintenance Notice</span>
                      <h4 class="card-title my-3">Database Optimization</h4>
                      <h6 class="fs-2 mb-3">Date:  June 18, 2025</h6>
                      <p class="card-text">
                        Scheduled performance maintenance will occur on June 25, 2AM–4AM AST. Minimal service disruption expected.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">System Update</span>
                      <h4 class="card-title my-3">Enhanced Reporting Tools</h4>
                      <h6 class="fs-2 mb-3">Date:  June 14, 2025</h6>
                      <p class="card-text">
                        Users can now generate customiazable utilization reports by date range, type, and status.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">Security Patch</span>
                      <h4 class="card-title my-3">Login Verification Update</h4>
                      <h6 class="fs-2 mb-3">Date:  June 10, 2025</h6>
                      <p class="card-text">
                        Two-factor authentication is now mandatory for all admin accounts for improved security.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">Announcement</span>
                      <h4 class="card-title my-3">New Help aCenter Live</h4>
                      <h6 class="fs-2 mb-3">Date: June 5, 2025</h6>
                      <p class="card-text">
                        Our new Help & Support section includes updated FAQs, guides, and tutorial videos.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 my-2">
                  <div class="card mb-0 h-100">
                    <img class="card-img-top img-responsive" src="../assets/images/blog/blog-default.png" alt="Card image cap"/>
                    <div class="card-body">
                      <span class="tag bg-success-subtle border border-success text-success fs-2 px-2 py-1 mb-3">Release</span>
                      <h4 class="card-title my-3">Version 2.5 Deployed</h4>
                      <h6 class="fs-2 mb-3">Date:  June 1, 2025</h6>
                      <p class="card-text">
                        Version 2.5 includes UI improvements, bug fixes, and faster load times.
                      </p>
                      <a href="javascript:void(0)" class="text-primary">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

            </div>
        </div>
     
  );
};

export default News;